import React, { Component } from 'react';

const STEPS = [
  { number: 1, label: 'Plan' },
  { number: 2, label: 'Info' },
  { number: 3, label: 'Payment' }
];

export default class ProgressSteps extends Component {
  renderConnector(isActive) {
    const connectorClass = [
      'progress-steps__connector',
      isActive ? 'progress-steps__connector--active' : ''
    ]
      .join(' ')
      .trim();
    return <div className={connectorClass} />;
  }

  renderCircle(step, isActive, isCompleted) {
    const circleClass = [
      'progress-steps__circle',
      isActive ? 'progress-steps__circle--active' : '',
      isCompleted ? 'progress-steps__circle--completed' : ''
    ]
      .join(' ')
      .trim();
    return (
      <div className={circleClass}>
        {isCompleted ? (
          <svg
            className="progress-steps__checkmark"
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M20 6 9 17l-5-5" />
          </svg>
        ) : (
          step.number
        )}
      </div>
    );
  }

  render() {
    const currentStep = this.props.currentStep || 1;

    return (
      <div className="progress-steps">
        {STEPS.map((step, index) => {
          const isActive = step.number === currentStep;
          const isCompleted = step.number < currentStep;
          const isLast = index === STEPS.length - 1;
          const labelClass = [
            'progress-steps__label',
            isActive || isCompleted ? 'progress-steps__label--active' : ''
          ]
            .join(' ')
            .trim();

          return (
            <div className="progress-steps__item" key={step.number}>
              {this.renderCircle(step, isActive, isCompleted)}
              <span className={labelClass}>{step.label}</span>
              {!isLast && this.renderConnector(isCompleted)}
            </div>
          );
        })}
      </div>
    );
  }
}

